import { Text } from '@nvision/ui';

import { FormSchema, useSuspensePricingValidationSchema, VALIDATION_SCHEMA_KEYS } from '@/modules/validators';

import { ContractForm, type ContractFormProps } from './contract-form';

import styles from './contract-details.module.css';

export const ContractDetails: React.FC<ContractFormProps> = (props) => {
  const { data: contractSchema } = useSuspensePricingValidationSchema(VALIDATION_SCHEMA_KEYS.contract.create);

  return (
    <FormSchema schema={contractSchema.validationSchema}>
      <section className={styles.section}>
        <div className={styles.header}>
          <Text size="sm" weight="semibold">
            Details
          </Text>
        </div>

        <ContractForm {...props} />
      </section>
    </FormSchema>
  );
};
